import { useEffect, useRef } from "react"
import { Call } from "@twilio/voice-sdk"

export function formatCallDuration(seconds: number): string {
  const hrs = Math.floor(seconds / 3600)
  const mins = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  return [hrs > 0 ? String(hrs).padStart(2, "0") : "", String(mins).padStart(2, "0"), String(secs).padStart(2, "0")]
    .filter(Boolean)
    .join(":")
}

export function useCallTimer(currentCall: Call, setCallDuration: (duration: any) => void): void {
  const timerRef = useRef<number | null>(null)
  useEffect(() => {
    if (currentCall) {
      timerRef.current = window.setInterval(() => {
        setCallDuration((prev: number) => prev + 1)
      }, 1000)
    } else {
      if (timerRef.current) {
        clearInterval(timerRef.current)
        timerRef.current = null
      }
      setCallDuration(0)
    }

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current)
      }
    }
  }, [currentCall, setCallDuration])
}
